import {HttpRequest} from '../../../util/http';

export const flipNotifyUser = (userId, notifyStatus) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
      update_notify: notifyStatus ? 1 : 0
    }
    const method = 'POST'
    let success = false;
    HttpRequest.fetch<any>("scripts/users/update_notify", {data, method}).then((res) => {
      if (res.message === "success") success = true;
      resolve(success)
    });
  });
};

export const changeActiveStatus = (userId: number) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
      active: 0,
    }
    const method = 'POST'
    let success = false;
    HttpRequest.fetch<any>("scripts/user_delete", {data, method}).then((res) => {
      if (res.message === "success") success = true;
      resolve(success)
    });
  });
};

export const updatePassword = (userId: number, password: string) => {
  return new Promise((resolve, reject) => {
    const data = {
      user: userId,
      password: password,
    }
    const method = 'POST'
    let success = false;
    HttpRequest.fetch<any>("scripts/users/update_password", {data, method}).then((res) => {
      if (res.message === "success") success = true;
      resolve(success)
    });
  });
}


export const addUser = () => {
  window.location.href = 'user_manage_add';
}

export const exportUserList = () => {
  const userList = "this is the export button function"
  let filename = "user_" + new Date().toJSON().slice(0,10) + ".csv"
  $.ajax({ 
      url: '/scripts/users/exportUsers',
      data: {userList},
      type: 'post',
      dataType: 'json',
      success: function (data) {
          var csvContent = data
          var link = window.document.createElement("a");
          link.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent));
          link.setAttribute("download", filename);
          link.click();
      }.bind(this)
  })
}
